export default {"src":"/_next/static/media/top_icon.7519ae38.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};